export function obtenerAnioMesActual() {
  const hoy = new Date()

  return { anio: hoy.getFullYear(), mes: hoy.getMonth() }
}

export function obtenerMesAnterior(anio, mes) {
  if (mes === 0) return { anio: anio - 1, mes: 11 }

  return { anio, mes: mes - 1 }
}

export function formatearInicioMes(anio, mes) {
  const mesTexto = String(mes + 1).padStart(2, '0')

  return `${anio}-${mesTexto}-01`
}

export function obtenerClaveMes(anio, mes) {
  return `${anio}-${String(mes + 1).padStart(2, '0')}`
}

export function obtenerClaveMesDesdeFecha(fechaTexto) {
  if (!fechaTexto) return ''

  const [anio, mes] = fechaTexto.split('-')

  return anio && mes ? `${anio}-${mes}` : ''
}

export function nombreMesCorto(anio, mes) {
  const nombre = new Date(anio, mes, 1)
    .toLocaleDateString('es-CL', { month: 'short' })
    .replace('.', '')

  return nombre.charAt(0).toUpperCase() + nombre.slice(1)
}

export function nombreMesLargo(anio, mes) {
  const nombre = new Date(anio, mes, 1).toLocaleDateString(
    'es-CL',
    { month: 'long' }
  )

  return nombre
}

export function generarUltimosMeses(
  cantidad,
  anioReferencia,
  mesReferencia
) {
  const meses = []
  let anio = anioReferencia
  let mes = mesReferencia

  for (let indice = 0; indice < cantidad; indice += 1) {
    meses.unshift({ anio, mes })

    const anterior = obtenerMesAnterior(anio, mes)
    anio = anterior.anio
    mes = anterior.mes
  }

  return meses
}

export function generarMesesDelAnio(
  anioReferencia,
  mesReferencia
) {
  const meses = []

  for (let mes = 0; mes <= mesReferencia; mes += 1) {
    meses.push({ anio: anioReferencia, mes })
  }

  return meses
}
